import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

export default function Pager({ current, total, path }) {
  const { t } = useTranslation("common");

  if (total <= 1) return null;

  const [previous, hasPrevious] = [current - 1, current > 1];
  const [next, hasNext] = [current + 1, current < total];

  return (
    <div className="text-center">
      <div className="inline-flex items-center justify-center gap-8 mt-16 py-6 px-12 rounded-full">
        {hasPrevious && (
          <Link
            href={previous === 1 ? path : `${path}/pages/${previous}`}
            passHref
          >
            <a className="group flex items-center">
              <ChevronLeftIcon className="h-4 w-4 mr-2" />
              <span className="underline underline-offset-4 decoration-transparent group-hover:decoration-white transition-colors">
                {t("utils.previous")}
              </span>
            </a>
          </Link>
        )}

        <div>
          <span>{current}</span>
          <span className="px-2 opacity-50">/</span>
          <span>{total}</span>
        </div>

        {hasNext && (
          <Link href={`${path}/pages/${next}`} passHref>
            <a className="group flex items-center">
              <span className="underline underline-offset-4 decoration-transparent group-hover:decoration-white transition-colors">
                {t("utils.next")}
              </span>
              <ChevronRightIcon className="h-4 w-4 ml-2" />
            </a>
          </Link>
        )}
      </div>
    </div>
  );
}
